let config = {
    loadedClass: 'lazy-loaded',
    observedClass: 'lazy-observed',
    selector: '[data-src],[data-style]',
    scriptClickSelector: '[data-load-script]',
    scriptLoadingClass: 'script-loading',
    rootMargin: '50px 0px', // If the element gets within 50px in the Y axis, start the download.
    threshold: 0.01
};

let userInteractions = [ 'keydown', 'mouseover', 'touchmove', 'mousedown' ];
let elements = null;
let elementCount = null;
let observer = null;
let lazyScriptsLoaded = false;
let initd = false;

function init() {
    elements = document.querySelectorAll( config.selector );
    elementCount = elements.length;

    // If we don't have support for intersection observer, loads the elements immediately
    if ( !( 'IntersectionObserver' in window ) ) {
        loadImmediately( elements );
    } else {
        // It is supported, load the elements
        observer = new IntersectionObserver( ( entries ) => onIntersection( entries ), config );

        for ( let i = 0; i < elements.length; i++ ) {
            let element = elements[ i ];

            element.classList.add(config.observedClass);

            if ( element.classList.contains( config.loadedClass ) ) {
                elementCount--;
                continue;
            }

            observer.observe( element );
        }
    }

    initd = true;
}

/**
 * Loads all of the elements immediately
 */
function loadImmediately() {
    for ( let i = 0; i < elements.length; i++ ) {
        loadElement( elements[ i ] );
    }
}

/**
 * Loads a single element
 */
function loadElement( el ) {
    if ( el.dataset.style ) {
        el.style = el.dataset.style;
    } else if ( el.dataset.src ) {
        el.src = el.dataset.src;
    }

    // Add the "loaded" class
    el.classList.add( config.loadedClass );
}

/**
 * Fires when observed elements come into view
 */
function onIntersection( entries ) {
    // Disconnect if we've already loaded all of the elements
    if ( elementCount === 0 ) {
        disconnect();
        return;
    }

    // Loop through the entries
    for ( let i = 0; i < entries.length; i++ ) {
        let entry = entries[ i ];

        //  Stop watching and load the element if we are in viewport
        if ( entry.intersectionRatio > 0 ) {
            elementCount--;
            observer.unobserve( entry.target );
            loadElement( entry.target );
        }
    }
}

function disconnect() {
    if ( observer ) {
        observer.disconnect();
    }
}

init();

window.addEventListener( 'lazyload:init', init );
